angular.module('unica_feedback.feedback_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MATERIAL
		.state('app.feedback', {
			url: '/feedback',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/feedback/templates/feedback.html',
					controller: 'FeedbackBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// FEEDBACK LIST
		.state('app.feedback.list', {
			url: '/list/:event_id/:category_id',
			views: {
				'feedbackContent': {
					templateUrl: './modules/feedback/templates/list.html',
					controller: 'FeedbackListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Feedback',
				parent: function($scope) {
					return 'app.feedback_category.list({event_id: ' + $scope.event_id + ' })';
				}
			}
		})

		// FEEDBACK DETAIL
		.state('app.feedback.detail', {
			url: '/detail/:event_id/:category_id/:id',
			views: {
				'feedbackContent': {
					templateUrl: './modules/feedback/templates/detail.html',
					controller: 'FeedbackDetailController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Dettagli Feedback',
				parent: function($scope) {
					return 'app.feedback.list({event_id: ' + $scope.event_id + ', category_id: ' + $scope.category_id + ' })';
				}
			}
		});

});

